import { Box } from '@mui/material'
import { Loading } from './Loading';

interface LoadingBackgroundProps {
    top?: string | number;
    left?: string | number;
    id?: string;
}

export const LoadingBackground = ({
    top, left, id
}: LoadingBackgroundProps) => {
    return (
        <Box id={id ?? 'loading'} sx={{ position: 'relative' }}>
            <Box sx={{ position: 'absolute', top: top ?? 50, left: left ?? 40, zIndex: 999 }}>
                <Loading />
            </Box>
        </Box>
    )
}
